<div class="get-resource-definition" *ngIf="!waitingForResponse && !failedToGetDefinition">
  <app-popup-top-line></app-popup-top-line>
  <div class="get-resource-definition-header">
    <div class="title">{{ title }}</div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="closeWindow()" />
  </div>

  <div class="get-resource-definition-body">
    <div>
      <div class="get-resource-definition-body-raw-json-container">
        <div class="raw-json-field-description">
          {{ description }}
        </div>

        <div class="raw-json-field-value-container">
          <app-copy-button
            class="raw-json-field-copy-button"
            [successPopupPosition]="popupPosition.Left"
            [value]="rawJson"
          ></app-copy-button>
          <pre class="raw-json-field-value" disabled="true">{{ rawJson }}</pre>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="missing-resource-definition" *ngIf="!waitingForResponse && failedToGetDefinition">
  <app-no-data tableNotFoundText="Failed to get data "></app-no-data>
</div>
<div class="get-resource-definition-spinner" *ngIf="waitingForResponse">
  <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
</div>
